var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 2950 1309",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_j5XJnBLLfNcRDMowIgWj5o508s5RSP3J"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2950,
    height: 1309
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_j5XJnBLLfNcRDMowIgWj5o508s5RSP3J)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_s1e6kuBjzoDjmCrMUfbxe8tcagwBqUBl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2950,
    height: 1309,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_s1e6kuBjzoDjmCrMUfbxe8tcagwBqUBl)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2950,
    height: 1310.051,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(2,101,244)"
  })), /*#__PURE__*/React.createElement("path", {
    d: " M -119.703 1717.948 C 94.973 1770.655 299.017 1574.035 475.442 1410.132 C 644.238 1253.315 786.14 1051.438 863.307 804.703 C 938.216 565.184 918.88 305.531 901.191 48.821 C 882.522 -222.11 916.344 -546.783 757.591 -729.506 C 597.691 -913.548 338.222 -772.117 129.052 -839.898 C -69.265 -904.162 -236.629 -1191.967 -432.125 -1115.032 C -628.157 -1037.886 -651.754 -693.54 -774.129 -484.465 C -884.584 -295.755 -1054.214 -168.303 -1115.972 53.314 C -1185.081 301.311 -1248.049 601.965 -1139.284 825.896 C -1030.039 1050.818 -754.623 1000.235 -583.203 1150.214 C -402.759 1308.088 -334.892 1665.115 -119.703 1717.948 Z ",
    fill: "rgb(0,25,73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 2386.771 589.643 C 2329.942 795.135 2451.458 1002.578 2508.34 1211.044 C 2567.73 1428.703 2531.686 1712.931 2727.69 1839.083 C 2928.246 1968.166 3187.967 1800.821 3426.46 1801.967 C 3617.427 1802.884 3805.515 1897.142 3987.112 1845.135 C 4179.654 1789.994 4324.233 1650.202 4456.772 1506.899 C 4608.626 1342.714 4827.384 1178.613 4809.096 956.405 C 4790.689 732.758 4506.161 624.681 4368.955 439.923 C 4240.604 267.088 4206.275 36.931 4030.494 -92.042 C 3835.583 -235.051 3586.47 -348.881 3349.201 -308.287 C 3113.704 -267.996 2980.961 -41.963 2811.009 116.6 C 2652.374 264.603 2443.889 383.103 2386.771 589.643 Z ",
    fill: "rgb(245,79,100)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.ca3cf26a472c7061759bb9f01c1cdf2e.svg";
export { ForwardRef as ReactComponent };